<template>
  <div>
    <hnavbar />
    <Content pagetitle="SPECIAL PROGRAMME APPLICATION">
      <form role="form" @submit.prevent="submitAndProceed">
        <box boxheading="PERSONAL INFORMATION">
          <div class="box-body">
            <div class="row">
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="surname"
                    >Student Surname <span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="surname"
                    name="surname"
                    v-model="formdata.surname"
                    placeholder="Enter surname"
                    v-validate="'required'"
                    data-vv-as="surname"
                  />
                </div>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('surname')"
                  >{{ errors.first("surname") }}</span
                >
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="firstname"
                    >First Name <span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="firstname"
                    name="firstname"
                    v-model="formdata.firstname"
                    placeholder="Enter firstname"
                    v-validate="'required'"
                    data-vv-as="firstname"
                  />
                </div>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('firstname')"
                  >{{ errors.first("firstname") }}</span
                >
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="othername"
                    >Other Name<span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="othername"
                    name="othername"
                    v-model="formdata.othername"
                    placeholder="Enter othername"
                    v-validate="'required'"
                    data-vv-as="othername"
                  />
                </div>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('othername')"
                  >{{ errors.first("othername") }}</span
                >
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="dob"
                    >Date of Birth <span style="color: red">*</span></label
                  >
                  <input
                    type="date"
                    class="form-control"
                    id="dob"
                    name="dob"
                    v-model="formdata.dob"
                    v-validate="'required'"
                    data-vv-as="Date of Birth"
                  />
                </div>
                <span class="text-danger text-sm" v-show="errors.has('dob')">{{
                  errors.first("dob")
                }}</span>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="placeofbirth"
                    >Place of Birth <span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="placeofbirth"
                    name="placeofbirth"
                    v-model="formdata.placeofbirth"
                    v-validate="'required'"
                    data-vv-as="Date of Birth"
                  />
                </div>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('placeofbirth')"
                  >{{ errors.first("placeofbirth") }}</span
                >
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="father"
                    >Father's Name <span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="father"
                    name="father"
                    v-model="formdata.fathername"
                    v-validate="'required'"
                    data-vv-as="fathername"
                  />
                </div>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('fathername')"
                  >{{ errors.first("fathername") }}</span
                >
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="mothername"
                    >Mother's Name <span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="mothername"
                    name="mothername"
                    v-model="formdata.mothername"
                    v-validate="'required'"
                    data-vv-as="mothername"
                  />
                </div>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('mothername')"
                  >{{ errors.first("mothername") }}</span
                >
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="lastschool"
                    >Previous School(s) Attended
                    <span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="lastschool"
                    name="lastschool"
                    v-model="formdata.lastschool"
                    v-validate="'required'"
                    data-vv-as="Last School Attended"
                  />
                </div>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('lastschool')"
                  >{{ errors.first("lastschool") }}</span
                >
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="emergencycontactname"
                    >Emergency Contact Name
                    <span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="emergencycontactname"
                    name="emergencycontactname"
                    v-model="formdata.emergencycontactname"
                    v-validate="'required'"
                    data-vv-as="Emergency Contact Name"
                  />
                </div>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('emergencycontactname')"
                  >{{ errors.first("emergencycontactname") }}</span
                >
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="emergencycontactphone"
                    >Mobile No <span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="emergencycontactphone"
                    name="emergencycontactphone"
                    v-model="formdata.emergencycontactphone"
                    v-validate="'required'"
                    data-vv-as="Emergency Contact Phone"
                  />
                </div>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('emergencycontactphone')"
                  >{{ errors.first("emergencycontactphone") }}</span
                >
              </div>
            </div>
          </div>
        </box>
        <box boxheading="PROGRAMMES/QUALIFICATIONS REGISTERING:">
          <div class="row">
            <div class="col-sm-6">
              <label for="programmes"
                >PROGRAMMES(Please Select as many as you can OR Type in and
                select if option is not found)</label
              >
              <v-select
                taggable
                multiple
                :options="programmes"
                name="programmes"
                v-model="formdata.programmes"
              ></v-select>
            </div>
            <div class="col-sm-6">
              <label for="qualifications"
                >QUALIFICATION(S) OBTAINED(Please Select as many as you can OR
                Type in and select if option is not found)</label
              >
              <v-select
                taggable
                multiple
                :options="qualifications"
                name="qualifications"
                v-model="formdata.qualifications"
              ></v-select>
            </div>
          </div>
        </box>
        <box boxheading="How did you get to know the school:">
          <div class="row">
            <div class="col-sm-7">
              <div class="form-group">
                <label for="gettoknow"
                  >How did you get to know the school</label
                >
                <select
                  name="gettoknow"
                  id="gettoknow"
                  class="form-control"
                  v-model="formdata.gettoknow"
                >
                  <option value="">Please select</option>
                  <option value="Poster">Poster</option>
                  <option value="Friends">Friends</option>
                  <option value="Radio Adverts">Radio Adverts</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            </div>
          </div>
        </box>
        <box boxheading="GUARANTOR INFORMATION">
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label for="gname"
                  >Guarantor Name <span style="color: red">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="gname"
                  name="gname"
                  v-validate="'required'"
                  data-vv-as="Guarantor Name"
                  v-model="formdata.gname"
                />
              </div>
              <span class="text-danger text-sm" v-show="errors.has('gname')">{{
                errors.first("gname")
              }}</span>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="gphone"
                  >Guarantor Phone <span style="color: red">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="gphone"
                  name="gphone"
                  data-vv-as="Guarantor Phone"
                  v-validate="'required'"
                  v-model="formdata.gphone"
                />
              </div>
              <span class="text-danger text-sm" v-show="errors.has('gphone')">{{
                errors.first("gphone")
              }}</span>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="gemail"
                  >Guarantor Email <span style="color: red">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="gemail"
                  name="gemail"
                  data-vv-as="Guarantor Email"
                  v-validate="'required'"
                  v-model="formdata.gemail"
                />
              </div>
              <span class="text-danger text-sm" v-show="errors.has('gemail')">{{
                errors.first("gemail")
              }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label for="relationship"
                  >Relationship <span style="color: red">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="relationship"
                  name="relationship"
                  data-vv-as="Relationship"
                  v-validate="'required'"
                  v-model="formdata.relationship"
                />
              </div>
              <span
                class="text-danger text-sm"
                v-show="errors.has('relationship')"
                >{{ errors.first("relationship") }}</span
              >
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="Profession"
                  >Profession <span style="color: red">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="Profession"
                  name="Profession"
                  data-vv-as="Profession"
                  v-validate="'required'"
                  v-model="formdata.profession"
                />
              </div>
              <span
                class="text-danger text-sm"
                v-show="errors.has('profession')"
                >{{ errors.first("profession") }}</span
              >
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="date">Date <span style="color: red">*</span></label>
                <input
                  type="date"
                  class="form-control"
                  id="date"
                  name="date"
                  data-vv-as="Date"
                  v-validate="'required'"
                  v-model="formdata.date"
                />
              </div>
              <span class="text-danger text-sm" v-show="errors.has('date')">{{
                errors.first("date")
              }}</span>
            </div>
          </div>
        </box>
        <div class="box-footer center" style="display: block; margin: auto">
          <button type="submit" class="btn btn-primary btn-lg">Submit</button>
        </div>
      </form>
    </Content>
    <BlockUI :message="msg" v-if="blockui"></BlockUI>
  </div>
</template>

<script>
import hnavbar from "../components/HNavBar.vue";
import Content from "../components/Content.vue";
import Box from "../components/Box.vue";
export default {
  name: "Wassce",
  components: {
    hnavbar,
    Content,
    Box,
  },
  data() {
    return {
      msg: "Please wait",
      blockui: false,
      programmes: ["TOEFL", "IELTS", "SAT", "GRE", "GMAT"],
      qualifications: [
        "S.S.C.E",
        "H.N.D",
        "IST DEGREE",
        "I.G.A.G",
        "CIMG",
        "CIM(UK)",
        "CIMA",
        "A.C.C.A",
      ],
      formdata: {
        subjects: 1,
        surname: "",
        othername: "",
        firstname: "",
        dob: "",
        placeofbirth: "",
        fathername: "",
        mothername: "",
        emergencycontactname: "",
        emergencycontactphone: "",
        lastschool: "",
        programmes: [],
        qualifications: [],
        gettoknow: "",
        gname: "",
        gphone: "",
        gemail: "",
        relationship: "",
        Profession: "",
        date: "",
      },
    };
  },
  methods: {
    submitAndProceed() {
      this.$validator
        .validateAll()
        .then((valid) => {
          if (valid) {
            this.blockui = true;
            console.log(this.formdata);
            this.axios
              .post(this.appenv.baseurl + "/special", this.formdata)
              .then((response) => {
                console.log(response.data);
                this.blockui = false;
                if (response.data && response.data.status === "success") {
                  this.$router.push("/complete");
                } else {
                  this.$alert(
                    "Ooops.. Processing failed. Please try again",
                    "Alert",
                    "error"
                  );
                }
              })
              .catch(() => {
                this.blockui = false;
                this.$alert(
                  "Ooops.. Processing failed. Please try again",
                  "Alert",
                  "error"
                );
              });
          }
        })
        .catch(() => {
          this.blockui = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
